import React from 'react'
import {Navigate} from 'react-router-dom'
import {ASSETS_PATH} from 'constants/path'
import AssetsLayout from 'layouts/Assets.layout'

const assetsRoutes = [
  {
    path: 'assets',
    handle: {title: 'Assets'},
    element: <AssetsLayout />,
    children: [
      {index: true, element: <Navigate to={ASSETS_PATH.ALL} />},
      {
        path: ASSETS_PATH.ALL,
        handle: {title: 'All Assets'},
        lazy: () => import('components/pages/Assets/AssetsList'),
      },
      {
        path: ASSETS_PATH.DEFAULT,
        handle: {title: 'Default'},
        lazy: () => import('components/pages/Assets/Default/Default'),
      },
      {
        path: ASSETS_PATH.FIELDS,
        handle: {title: 'Fields'},
        lazy: () => import('components/pages/Assets/Fields/Fields'),
      },
      {
        path: ASSETS_PATH.IMPORT,
        handle: {title: 'Import'},
        lazy: () => import('components/pages/Assets/Import'),
      },
    ],
  },
]

export default assetsRoutes
